'use es6';
import { Record } from 'immutable';

const TypedRecord = (defaults, name = 'TypedRecord') => {
  const RecordClass = Record(defaults, name);
  Object.defineProperty(RecordClass, 'name', { value: name });
  return RecordClass;
};

export default TypedRecord;
